import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { evaluationGet } from "#performance-evaluation/services/api"
import { Box, Stack, Typography } from "@mui/material"
import { useMemo } from "react"
import { MyEvaluationsCard } from "./MyEvaluationsCard"
import { useReloadRedux } from "app/reload"
import MyEvaluationsAdd from "./MyEvaluationsAdd"

export function MyEvaluationsItems({ collaboratorId }) {
	const { reload } = useReloadRedux()
	const params = useMemo(
		() => ({
			colaborador: collaboratorId,
		}),
		[collaboratorId],
	)
	const { data, loading, error } = useApi(evaluationGet, {
		params,
		autoFetch: true,
		reload,
	})
	const { evaluations, count, is_active, jefe_directo } = useMemo(
		() => data || {},
		[data],
	)
	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	const evaluationsItems = evaluations.map((evaluation) => (
		<MyEvaluationsCard
			key={evaluation.id}
			evaluation={evaluation}
			jefe_directo={jefe_directo}
		/>
	))
	let noItems = null
	if (count === 0)
		noItems = (
			<Box>
				<Typography variant="h6" align="center">
					No cuentas con evaluaciones
				</Typography>
			</Box>
		)

	return (
		<Box m={2} display="flex" flexDirection="column" alignItems="center" gap={2} p={0}>
			<MyEvaluationsAdd hidden={is_active} />
			{noItems}
			<Stack spacing={1} width={"100%"} direction={"column"}>
				{evaluationsItems}
			</Stack>
		</Box>
	)
}
